import React, { useCallback, useState } from "react";
import { Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import FileMightBeHarmful from "../../../images/file-might-be-harmul-image.png";
import SSLImage from "../../../images/ssl-image.png";
import FacePile from "../../../images/face-pile.png";
import PrimaryActionButton from "../../../components/Buttons/PrimaryActionButton/PrimaryActionButton";
import "./DownloadInstructionsPage1.scss";
import { useDownloadApp } from "../../../hooks/useDownloadApp";
import { ROUTES } from "../../../utils/constants";
import { showSuccessToast } from "../../../utils/show-toast";
import WhyUseApkModal from "../modals/WhyUseApkModal/WhyUseApkModal";
import AppIsDownloadingModal from "../modals/AppIsDownloadingModal/AppIsDownloadingModal";
import StartAuthModal from "../../../components/onboarding/StartAuthModal/StartAuthModal";
import GhostButton from "../../../components/dashboard-page/GhostButton/GhostButton";
import ImageBackIcon from "../../../images/arrow-left-black.svg";
import InfoIcon2 from "../../../components/icons/InfoIcon2";
import ImageAndroidIcon from "../../../images/android-icon.svg";

function DownloadInstructionsPage1() {
  const { apk } = useDownloadApp();
  const navigate = useNavigate();
  const [isWhyApkModalOpen, setIsWhyApkModalOpen] = useState(false);
  const [isAppDownloadingModalOpen, setIsAppDownloadingModalOpen] =
    useState(false);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  function handleStartDownloadClick() {
    showSuccessToast("Download Started");
    setIsAppDownloadingModalOpen(true);
  }

  const onHideParent = useCallback((isGoBack?: boolean) => {
    !isGoBack && setIsAuthModalOpen(true);
    setIsAppDownloadingModalOpen(false);
  }, []);

  const onHideWhyUseApkModal = useCallback(
    () => setIsWhyApkModalOpen(false),
    []
  );

  return (
    <div className="MobileOnly position-relative download-instructions-page-1 px-0">
      <div className="download-instructions-page-1-content  flex-column justify-content-center">
        <p className="d-flex mb-1 ps-2">
          <GhostButton
            aria-label="go back"
            onClick={() => navigate(ROUTES.ROOT.HOME)}
            className="d-inline"
          >
            <Image src={ImageBackIcon} width={30} height={30} alt="back" />
          </GhostButton>
        </p>
        <div className="px-3">
          <h1 className="to-start-download-text text-black">
            Hyper is available only as an Android APK due to gaming rewards.
            <GhostButton
              aria-label="Open info dialog"
              onClick={() => setIsWhyApkModalOpen(true)}
              className="p-0 d-inline-flex InfoButton"
            >
              <InfoIcon2 />
            </GhostButton>
          </h1>
          <p className="tap-download-instructions text-black mb-2">
            Tap <b>"Download anyway"</b> when you see this pop up 👇
          </p>
          <Image
            src={FileMightBeHarmful}
            alt="file-might-be-harmful-image"
            className="file-harmful-image"
          />
          <Image src={SSLImage} alt="ssl_image" className="ssl-image mt-3" />

          <div className="trusted-by-container  MobileOnly">
            <p className="trusted-by-statement text-black">
              {" "}
              <b>Trusted by over 30 thousand users </b>
            </p>
            <Image className="face-pile" src={FacePile} alt="face_pile" />
          </div>
        </div>

        <div className="download-instructions-footer px-3 MobileOnly">
          <PrimaryActionButton
            id="start_dl_btn"
            textColor={"#FFFFFF"}
            text="Download Secure APK"
            textClassName="start-download-btn-text"
            onClick={handleStartDownloadClick}
            leftImage={ImageAndroidIcon}
            style={{
              display: "flex",
              justifyContent: "center",
              height: 52,
            }}
            href={apk.url}
          />
        </div>
      </div>
      <WhyUseApkModal show={isWhyApkModalOpen} onHide={onHideWhyUseApkModal} />
      <AppIsDownloadingModal
        show={isAppDownloadingModalOpen}
        onHideParent={onHideParent}
      />
      <StartAuthModal
        show={isAuthModalOpen}
        onHide={() => setIsAuthModalOpen(false)}
      />
    </div>
  );
}

export default DownloadInstructionsPage1;
